import type {z} from "zod";

import {ContactInputFields, PhoneNumberInput} from "@project/sdk/sales/zod";
import {z as zod} from "zod";

import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {contactFieldLabelIds} from "../../../../../../../support/messages/contact.messages";

const contactInputFields = ContactInputFields.shape;

export const addLeadContactNameSchema = requiredStringSchema(
  contactInputFields.name,
  contactFieldLabelIds.name,
);
export const addLeadContactEmailSchema = contactInputFields.email.or(zod.literal(""));

const addLeadContactFormFieldsSchema = zod.object({
  name: addLeadContactNameSchema,
  description: contactInputFields.description,
  email: addLeadContactEmailSchema,
  phone: PhoneNumberInput.shape.nationalNumber.optional(),
  phonePrefix: PhoneNumberInput.shape.regionCode.optional(),
});

export const addLeadContactFormSchema = addLeadContactFormFieldsSchema.superRefine((value, ctx) => {
  if (!value.email && !value.phone) {
    ctx.addIssue({code: "custom", message: "Email or phone is required", path: ["email"]});
  }

  if (value.phone && !value.phonePrefix) {
    ctx.addIssue({
      code: "custom",
      message: "Phone prefix is required",
      path: ["phonePrefix"],
    });
  }
});
export type AddLeadContactFormPayload = z.output<typeof addLeadContactFormSchema>;

export const draftAddLeadContactFormSchema = addLeadContactFormFieldsSchema.partial();
export type DraftAddLeadContactFormPayload = z.output<typeof draftAddLeadContactFormSchema>;
